var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"information"},[_c('div',{staticClass:"bread"},[_c('i',{staticClass:"el-icon-arrow-left",on:{"click":function($event){return _vm.goback()}}}),_vm._v(" 会议日程 ")]),_c('div',{staticClass:"content"})])
}
var staticRenderFns = []

export { render, staticRenderFns }